import React from "react";
import { LANDING } from "@/constants/testIds";

const steps = [
  {
    n: "01",
    title: "Discovery call",
    body: "A 30-minute conversation about your team, claims history, and what your current broker is — or isn't — doing.",
  },
  {
    n: "02",
    title: "Risk mapping",
    body: "We model your exposure across health, comp, liability and property — and tell you where you're over- and under-covered.",
  },
  {
    n: "03",
    title: "Carrier marketing",
    body: "We take your program to 40+ A-rated carriers and negotiate aggressively. You see every quote, side-by-side.",
  },
  {
    n: "04",
    title: "Bind & support",
    body: "We handle implementation, employee enrollment, certificates, and claims advocacy for the life of the policy.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid={LANDING.process}
      className="px-6 md:px-12 lg:px-24 py-24 md:py-32 bg-secondary/40 border-y border-border"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14">
        <div className="lg:col-span-5">
          <p className="label-eyebrow mb-4"><span className="text-accent">03</span> — How we work</p>
          <h2 className="font-display text-4xl md:text-5xl h-tight font-medium text-foreground">
            Four steps. <span className="italic font-light text-accent">No surprise</span>{" "}
            renewals.
          </h2>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 self-end">
          <p className="text-base md:text-lg text-muted-foreground max-w-xl">
            Most owners discover their coverage gaps mid-claim. Our process
            front-loads the diligence so you never have to.
          </p>
        </div>
      </div>

      <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-border rounded-md overflow-hidden border border-border">
        {steps.map((s) => (
          <li
            key={s.n}
            className="bg-background p-8 md:p-10 flex flex-col gap-6 min-h-[280px]"
          >
            <div className="flex items-baseline justify-between">
              <span className="font-display text-5xl font-light text-accent">
                {s.n}
              </span>
              <span className="h-px w-12 bg-accent" />
            </div>
            <h3 className="font-display text-xl md:text-2xl font-medium text-foreground tracking-tight">
              {s.title}
            </h3>
            <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
              {s.body}
            </p>
          </li>
        ))}
      </ol>
    </section>
  );
}
